import React, { useState, useEffect } from "react";
import { Chips } from "primereact/chips";
import { ErrorMessage } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { updatePostData } from "../../../../Redux/Slice/createPostSlice";
import Alerts from "../../../../components/common/Alerts/Alerts";
import {
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../../shared/businessLayoutSpec";
import {
  AdminHeaderAction,
  AdminLinkAction,
  AdminFormFieldError,
  AdminFilterChipButton,
  AdminFormFieldLabelRow,
  AdminDetailFieldLabel,
  adminWizardChipsClasses,
} from "../../../AdminDashboard/shared/adminUx";

const Keywords = ({ setStep, setFieldValue, values, handlePost }) => {
  const userPlan = useSelector((state) => state.user.userPlan?.plan?.name?.toLowerCase());
  const maxTags = userPlan === "pro" ? 10 : 5;
  const [originalSuggestions, setOriginalSuggestions] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const dispatch = useDispatch();
  const postKeywordsSuggestions =
    useSelector((state) => state.createPost.postKeywordsSuggestions) || [];
  const postTags = useSelector((state) => state.createPost.postTags) || [];

  useEffect(() => {
    if (postKeywordsSuggestions.length > 0 && originalSuggestions.length === 0) {
      const originalPostKeywordsSuggestions = [...postKeywordsSuggestions];
      setOriginalSuggestions(originalPostKeywordsSuggestions);
      const refPostKeywordsSuggestions = [...postKeywordsSuggestions];
      const filteredSuggestions = refPostKeywordsSuggestions.filter(
        (suggestion) => !postTags.includes(suggestion)
      );
      dispatch(updatePostData({ postKeywordsSuggestions: filteredSuggestions }));
    }
  }, []);

  const handleNextClick = () => {
    if (postTags.length > 0) {
      setIsUpdating(true);
    }
  };

  useEffect(() => {
    if (isUpdating && postTags?.length > 0) {
      handlePost();
      setIsUpdating(false);
      setStep(5);
    }
  }, [isUpdating, postTags]);

  const handleAddKeyword = (keyword) => {
    if (postTags.length < maxTags) {
      dispatch(updatePostData({ postTags: [...postTags, keyword] }));
      const updatedSuggestions = postKeywordsSuggestions.filter((tag) => tag !== keyword);
      dispatch(updatePostData({ postKeywordsSuggestions: updatedSuggestions }));
    } else {
      Alerts.error(`You can only add up to ${maxTags} tags with your ${userPlan} plan.`);
    }
  };

  return (
    <>
      <div className="w-full">
        <AdminFormFieldLabelRow
          label="Keywords"
          required
          tooltip={`Select from suggestions or type your own (maximum ${maxTags}).`}
        />
        <Chips
          id="addyourtags"
          placeholder="Enter relevant keywords"
          className={`${adminWizardChipsClasses(postTags.length > 0)} placeholder-lightgray text-offblack`}
          value={postTags}
          onChange={(e) => {
            if (e.value.length <= maxTags) {
              const removedTags = postTags.filter((tag) => !e.value.includes(tag));
              const suggestedTagsToAddBack = removedTags.filter((tag) =>
                originalSuggestions.includes(tag)
              );
              if (suggestedTagsToAddBack.length > 0) {
                dispatch(
                  updatePostData({
                    postKeywordsSuggestions: [
                      ...postKeywordsSuggestions,
                      ...suggestedTagsToAddBack,
                    ],
                  })
                );
              }
              dispatch(updatePostData({ postTags: e.value }));
            } else {
              Alerts.error(`You can only add up to ${maxTags} tags with your ${userPlan} plan.`);
            }
          }}
          separator=","
        />
        <ErrorMessage name="postTags">
          {(msg) =>
            msg ? <AdminFormFieldError className="mt-2">{msg}</AdminFormFieldError> : null
          }
        </ErrorMessage>

        {postKeywordsSuggestions && postKeywordsSuggestions.length > 0 && (
          <div className="mt-4">
            <AdminDetailFieldLabel>Suggested Keywords</AdminDetailFieldLabel>
            <div className="flex flex-wrap gap-2 w-full">
              {postKeywordsSuggestions.map((keyword, index) => (
                <AdminFilterChipButton
                  key={index}
                  type="button"
                  onClick={() => handleAddKeyword(keyword)}
                  className="!bg-mistygray !text-offblack hover:!bg-primaryblue hover:!text-white hover:!border-primaryblue"
                >
                  {keyword}
                </AdminFilterChipButton>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
        <AdminLinkAction type="button" onClick={() => setStep(3)}>
          Back
        </AdminLinkAction>
        <AdminHeaderAction
          type="button"
          onClick={handleNextClick}
          disabled={postTags.length === 0 || postTags.length > maxTags}
        >
          Next
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default Keywords;
